import { Component, signal } from '@angular/core';
import { params } from '@app/configurations';
import { RouterNavState } from '@app/core/store/states/router-nav/router-nav.state';
import { UserState } from '@app/core/store/states/user/user.state';
import { deepClone } from '@app/core/utilities/object.utilities';
import { ReplacePageParams } from '@app/core/utilities/url.utilities';
import { UserNamePipe } from '@app/shared/pipes/user-name.pipe';
import { select } from '@ngxs/store';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'adspt-impersonation-banner',
  templateUrl: './impersonation-banner.component.html',
  styleUrls: ['./impersonation-banner.component.scss'],
  imports: [NzAlertModule, UserNamePipe, IconComponent, NzTagModule],
})
export class ImpersonationBannerComponent {
  readonly minimize = signal(false);

  readonly user = select(UserState.user);
  readonly state = select(RouterNavState.queryParams);

  onImpersonationClose() {
    const state = deepClone(this.state());
    delete state[params.IMPERSONATION_ID];
    ReplacePageParams(state);
  }
}
